import { render, staticRenderFns } from "./shippingRegionDisplayPostcodes.vue?vue&type=template&id=7f1e13b4&scoped=true"
import script from "./shippingRegionDisplayPostcodes.vue?vue&type=script&lang=js"
export * from "./shippingRegionDisplayPostcodes.vue?vue&type=script&lang=js"
import style0 from "./shippingRegionDisplayPostcodes.vue?vue&type=style&index=0&id=7f1e13b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1e13b4",
  null
  
)

export default component.exports